/*
 * =============================================================================
 * Project: admin_panel
 * Created Date: 2018-03-16, 08:35:38
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-05-09, 09:49:47
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import React from 'react';
import { Alert } from "antd";

/**
 * Trait for form
 * 
 * @export
 * @class TForm
 */
export default class TForm {
  /**
   * Main state of component.
   * 
   * @memberof TForm
   */
  state = {
    loading: false,
    message: null,
    model: {},
    image: null,
    messageSuccessText: 'Poprawne dodanie nowego wpisu do listy.',
    messageErrorText: 'Błęd dodanie nowego wpisu do listy. Prosimy spróbować ponownie za chwilę.'
  } 

  /**
   * Fired when component will mount.
   * 
   * @memberof TForm
   */
  componentWillMount(){
    this.clearMessage();
    this.props.form.resetFields();
    this.toogleLodingSpinner(false);
  }

  /**
   * Resolve success response.
   * 
   * @memberof TForm
   */
  resolveSuccessResponseFromForm(cb = () => {}) {
    this.toogleLodingSpinner(false);
    cb();
  }

  /**
   * Resolve error response.
   * 
   * @memberof TForm
   */
  resolveErrorResponseFromForm() {
    this.toogleLodingSpinner(false);
    this.setMessageBeforSubmitForm('Błęd dane wejściowe. Prosimy spróbować ponownie za chwilę.');
  }


  /**
   * Clear message for form.
   * 
   * @memberof TForm
   */
  clearMessage() {
    this.setState({ message : null, image: null });
  }

  /**
   * Set message befor submit form.
   * 
   * @param {string} [text=''] 
   * @param {string} [type='error'] 
   * @memberof TForm
   */
  setMessageBeforSubmitForm(text = '', type = 'error') {
    this.setState({
      message : <Alert message={text}
        closable={true}
        type={type} /> 
    });
  }

  /**
   * Toogle loading spinner.
   * 
   * @param {boolean} [state=false] 
   * @memberof TForm
   */
  toogleLodingSpinner(state = false) {
    this.setState({
      loading: state
    });
  }
}


// WEBPACK FOOTER //
// ./src/rcapp/helpers/traits/formCreate.js